import React, {Component} from 'react';
import PropTypes from 'prop-types';
import slideInRight from 'react-animations/lib/slide-in-right';
import Radium, {StyleRoot} from 'radium';
import {Form, Input, Button, message, Modal, Tooltip} from 'antd';
import {LoadingOutlined} from '@ant-design/icons';
import {validateLogin} from '../../helpers/Validation/login';
import OnmoveLogo from '../../assets/images/onmoveLogo.png';
import {PATH} from '../../constants';
import Message from '../../Common/Message';
import './styles.less';
import internalToPulse from '../../assets/icons/internalToPulse.png';

const styles = {
  slideInRight: {
    animation: '1s',
    animationName: Radium.keyframes(slideInRight, 'slideInRight'),
  },
};

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
      username: null,
      password: null,
      otp: null,
      validationStatus: {},
      showOTP: false,
      timer: 60,
      visible: true,
    };
  }

  componentDidMount() {
    this.setState({isVisible: true});
    //PULSE starts............................

    // let secondsToGo = 30;
    // const modal = Modal.info({
    //   className: 'sign-in-container',
    //   footer: null,
    //   content: {
    //     display: 'none',
    //   },
    //   width: 800,
    //   style: {
    //     position: 'relative',
    //     top: '220px',
    //     height: '350px',
    //   },
    // });

    // const timer = setInterval(() => {
    //   secondsToGo -= 1;
    //   modal.update({
    //     content: (
    //       <div>
    //         <img
    //           style={{height: '60px', width: '200px'}}
    //           className="popupContainer"
    //           src={OnmoveLogo}
    //           alt={'logo'}
    //         />
    //         <div className="popup-container">
    //           <span className="redirect-text">Welcome aboard,</span>
    //           <span className="redirect-text">
    //             Our current portal link has been
    //           </span>
    //           <span className="discontinued-msg">
    //             discontinued from 5 January 2023
    //           </span>
    //           <span className="redirect-text">
    //             {' '}
    //             We are happy to announce that we are now PULSE.{' '}
    //           </span>
    //           <span>
    //             <img
    //               style={{height: '30px', width: '520px'}}
    //               src={internalToPulse}
    //               alt="link"
    //             />
    //           </span>
    //           {secondsToGo == 0 ? (
    //             <span className="redirecting-now-msg">
    //               {' '}
    //               Redirecting now ...
    //             </span>
    //           ) : (
    //             <span className="redirecting-msg">
    //               {' '}
    //               Redirecting in
    //               <span className="timer-text"> {secondsToGo}sec.</span>
    //             </span>
    //           )}
    //         </div>
    //       </div>
    //     ),
    //     className: 'sign-in-container',
    //   });
    // }, 1000);

    // setTimeout(() => {
    //   clearInterval(timer);
    //   window.location.href = 'https://pulse.onmove.in';
    // }, secondsToGo * 1000);

    //PULSE ends............................
  }

  componentDidUpdate() {
    if (this.state.timer === 0) {
      clearInterval(this.interval);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  login = async () => {
    const {signIn} = this.props;
    const {username, password, otp} = this.state;
    const user = {username, password, otp};
    const {valid, validationStatus} = validateLogin(this.state);
    if (valid) {
      this.setState({validationStatus: {...validationStatus}});
      const res = await signIn(user);
      const {otp_read = false, user_id, status = false} = res || null;
      if (status && otp_read) {
        this.props.history.replace('/');
        console.log('res ----', res);
        this.setState({showOTP: true, user_id}, this.setTime);
        const v = this.otpInput?.focus();
        return;
      } else if (status) {
        const {history: {location: {pathname} = {}} = {}} = this.props;
        console.log('pathname ----', pathname);
        let path = pathname;
        if (pathname === PATH.SIGN_IN || pathname === PATH.LOGOUT) {
          path = PATH.ROOT;
        }
        console.log('path ----', path);
        // this.props.history.replace(path);
      }
    } else {
      this.setState({validationStatus: {...validationStatus}});
    }
  };

  valuesChange = (e) => {
    this.setState({...e});
  };

  setTime = () => {
    this.interval = setInterval(
      () => this.setState((prevState) => ({timer: prevState.timer - 1})),
      1000,
    );
  };

  resendOTP = () => {
    const {user_id, username} = this.state;
    this.props.resendOTP({user_id, username}).then((result) => {
      const {status, message: text} = result;
      this.setState({timer: 60}, this.setTime);
      if (status) {
        message.success(`${text}`, 8);
      }
    });
  };

  forgotPassword = () => {
    this.props.history.push('/forgot-password');
  };

  render() {
    const {
      validationStatus: {username, password, otp} = {},
      isVisible,
      showOTP,
      timer,
    } = this.state;
    const {isLoading = false, error = ''} = this.props;

    return (
      <>
        <div className="flex row sign-in-container">
          <div className={`flex h100 w100`} style={{flex: '0.6'}} />
          {/* PULSE starts */}

          {/* <Modal
            centered
            visible={this.state.visible}
            footer={null}
            width={100}
            closable={false}
            bodyStyle={{
              display: 'none',
            }}
          /> */}

          {/* PULSE ends */}
          {isVisible && (
            <StyleRoot className="flex h100 w100" style={{flex: '0.4'}}>
              <div className="sign-in-form" style={styles.slideInRight}>
                <div className="flex flex-1 justify-content-center align-items-center">
                  <img className="onmove-logo" src={OnmoveLogo} alt={'logo'} />
                </div>
                <div className="flex flex-2 form-container">
                  <Form
                    name="user_login"
                    onFinish={isLoading ? null : this.login}
                    onValuesChange={this.valuesChange}>
                    <Form.Item
                      label="Username"
                      name="username"
                      validateStatus={username && username.status}
                      help={username && username.help}>
                      <Input
                        placeholder="Enter username"
                        className="input-box"
                        disabled={showOTP}
                      />
                    </Form.Item>
                    <Form.Item
                      label="Password"
                      name="password"
                      validateStatus={password && password.status}
                      help={password && password.help}
                      rules={[
                        {
                          validator: (_, value) =>
                            value && /\s/.test(value)
                              ? Promise.reject(
                                  new Error(
                                    'Password should not contain spaces',
                                  ),
                                )
                              : Promise.resolve(),
                        },
                      ]}>
                      <Input
                        type="password"
                        className="input-box"
                        placeholder="Enter password"
                        disabled={showOTP}
                      />
                    </Form.Item>
                    {showOTP && (
                      <>
                        <Form.Item
                          label="Verify OTP:"
                          name="otp"
                          validateStatus={otp && otp.status}
                          help={otp && otp.help}>
                          <Input
                            ref={(input) => {
                              this.otpInput = input;
                            }}
                            className="input-box"
                            placeholder="Enter OTP"
                            maxLength={6}
                          />
                        </Form.Item>
                        <div
                          className="resend-container"
                          onClick={timer === 0 ? this.resendOTP : null}>
                          <div
                            className={timer === 0 ? 'text' : 'text disabled'}>
                            Resend
                          </div>
                          {timer !== 0 && (
                            <div className={'text disabled ml8'}>{timer}</div>
                          )}
                        </div>
                      </>
                    )}
                    {!showOTP && (
                      <div
                        className="flex justify-content-end forget-password"
                        onClick={this.forgotPassword}>
                        Forget password?
                      </div>
                    )}
                    <div className="error-msg">
                      <Message message={error} type={'alert'} />
                    </div>
                    <Form.Item>
                      <Button type="primary" htmlType="submit">
                        {!isLoading ? (
                          'Login'
                        ) : (
                          <LoadingOutlined className="loading-icon" />
                        )}
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </StyleRoot>
          )}
        </div>
      </>
    );
  }
}

SignIn.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  signIn: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default SignIn;
